<template>
  <b-row>
    <b-col style="background-color: #f0f2f5" class="mx-auto" cols="10">
      <b-row>
        <b-col
          col
          lg="7"
          md="8"
          sm="8"
          style="margin-top: 10%"
          class="mx-auto d-none d-md-block"
        >
          <b-col
            cols="12"
            style="opacity: 0.8"
            class="card-block text-center ursb-description-info"
          >
            <div>
              <p style="font-size: 3vw">
                <!--                    <span style="color:  #db0000;"> ePosta </span> Uganda </p>-->

                <img
                  class="logo"
                  style="width: 30%; height: auto"
                  src="../../../public/eposta_logo_dark.png"
                />
              </p>

              <p style="font-size: 1.3vw">
                <!--                    <b>Postal Services</b> and <b>Government Services</b> Closer to You-->
              </p>

              <b-input-group class="mt-3">
                <div
                  class="form-group mb-3 input-group search-input-text-wrapper"
                >
                  <div class="input-group-prepend">
                    <span
                      class="input-group-text"
                      style="
                        background-color: #ffffff;
                        border: none;
                        border-radius: 30px;
                      "
                    >
                      <font-awesome-icon icon="search" style="color: #ced4da" />
                    </span>
                  </div>
                  <b-form-input
                    class="name-search-text-input"
                    type="text"
                    v-model="search_service"
                    required
                    placeholder="Enter Service name to search"
                  ></b-form-input>

                  <b-input-group-append>
                    <button
                      @click="search_services"
                      class="public-name-search-button"
                    >
                      Search
                      <b-spinner
                        v-if="serviceSearchSpinner"
                        small
                        label="Loading..."
                      ></b-spinner>
                    </button>
                  </b-input-group-append>
                </div>
              </b-input-group>
              <br />

              <p>
                <router-link to="/services" style="text-decoration: none"
                  ><b-avatar style="font-size: 12px" text="P"></b-avatar>&nbsp;
                  <span style="color: #000000">Postal Services</span>
                </router-link>
                &nbsp;
                <router-link
                  to="/services"
                  style="text-decoration: none"
                  class="ml-3"
                >
                  <b-avatar style="font-size: 12px" text="G"></b-avatar>&nbsp;
                  <span style="color: #000000">Government Services</span>
                </router-link>
                &nbsp;
                <router-link
                  to="/services"
                  style="text-decoration: none"
                  class="ml-3"
                  ><b-avatar style="font-size: 12px" text="L"></b-avatar>&nbsp;
                  <span style="color: #000000">licence Applications</span>
                </router-link>
                &nbsp;
              </p>

              <!--  <b-form-group>
                    <b-button to="/services" class="searchButtonCard form-control" >
                      <font-awesome-icon icon="search" style="color: #ffffff;"/> Services
                    </b-button>
                  </b-form-group>-->
            </div>
          </b-col>
        </b-col>

        <b-col
          col
          lg="4"
          md="8"
          sm="10"
          class="mx-auto"
          style="margin-top: 0%"
          v-if="showEnterCode"
        >
          <b-card class="loginCard">
            <b-form>
              <b-card-text style="font-size: 14px" class="text-center"
                >Verify with the code sent to your phone to access your
                account</b-card-text
              >
              <br />

              <b-form-group
                description="Find the code in an SMS sent to your phone number."
              >
                <div class="form-group mb-3 input-group input-text-wrapper">
                  <div class="input-group-prepend">
                    <span
                      class="input-group-text"
                      style="background-color: #ffffff; border: none"
                    >
                      <font-awesome-icon icon="key" style="color: #ced4da" />
                    </span>
                  </div>
                  <b-form-input
                    class="login-text-input"
                    id="input-email"
                    v-model="code"
                    type="text"
                    required
                    placeholder="Enter Code"
                  ></b-form-input>
                </div>
              </b-form-group>

              <b-form-group>
                <b-button
                  class="form-control signUpButtonCard button"
                  @click="verifyCode"
                  >Verify Code &nbsp;
                  <b-spinner
                    v-if="verifySpinner"
                    small
                    label="Loading..."
                  ></b-spinner>
                </b-button>
              </b-form-group>
            </b-form>
          </b-card>
        </b-col>

        <b-col
          col
          lg="4"
          md="8"
          sm="10"
          class="mx-auto"
          style="margin-top: 5%"
          v-if="showLogin"
        >
          <b-card class="loginCard">
            <b-form @submit="login">
              <br />
              <h5 class="text-center">
                Welcome back to <b style="color: #db0000">ePosta</b>
              </h5>
              <b-card-text style="font-size: 14px" class="text-center"
                >Please login to your account</b-card-text
              >
              <br />

              <div class="form-group mb-3 input-group input-text-wrapper">
                <div class="input-group-prepend">
                  <span
                    class="input-group-text"
                    style="background-color: #ffffff; border: none"
                  >
                    <font-awesome-icon icon="phone" style="color: #ced4da" />
                  </span>
                </div>
                <b-form-input
                  class="login-text-input"
                  id="input-email"
                  v-model="phone"
                  type="text"
                  required
                  placeholder="Phone"
                ></b-form-input>
              </div>

              <b-form-checkbox value="remember"> Remember Me </b-form-checkbox>

              <b-form-group>
                <b-button
                  class="form-control signUpButtonCard button"
                  type="submit"
                  >Continue &nbsp;
                  <b-spinner
                    v-if="loginSpinner"
                    small
                    label="Loading..."
                  ></b-spinner>
                </b-button>
              </b-form-group>

              <br />

              <hr />

              <b-form-group>
                <b-card-text class="text-center">
                  <span style="color: #7a7a7a; font-size: 15px"
                    >Do not have an account?
                    <a
                      class="inputLink"
                      @click="goToSignUp"
                      href="javascript:void(0)"
                      >Get an account</a
                    ></span
                  >
                </b-card-text>
              </b-form-group>
            </b-form>
          </b-card>
        </b-col>

        <b-col
          col
          lg="4"
          md="8"
          sm="10"
          class="mx-auto"
          style="margin-top: 5%"
          v-if="showSignUp"
        >
          <b-card class="loginCard">
            <b-form @submit="createAccount">
              <h5 class="text-center">
                Welcome back to <b style="color: #db0000">ePosta</b>
              </h5>
              <b-card-text style="font-size: 14px" class="text-center"
                >Please create your account.</b-card-text
              >
              <br />

              <div class="form-group mb-3 input-group input-text-wrapper">
                <div class="input-group-prepend">
                  <span
                    class="input-group-text"
                    style="background-color: #ffffff; border: none"
                  >
                    <font-awesome-icon icon="user" style="color: #ced4da" />
                  </span>
                </div>
                <b-form-input
                  class="login-text-input"
                  id="input-email"
                  v-model="signup_fname"
                  type="text"
                  required
                  placeholder="First Name"
                ></b-form-input>
              </div>

              <div class="form-group mb-3 input-group input-text-wrapper">
                <div class="input-group-prepend">
                  <span
                    class="input-group-text"
                    style="background-color: #ffffff; border: none"
                  >
                    <font-awesome-icon icon="user" style="color: #ced4da" />
                  </span>
                </div>
                <b-form-input
                  class="login-text-input"
                  id="input-email"
                  v-model="signup_lname"
                  type="text"
                  required
                  placeholder="Last Name"
                ></b-form-input>
              </div>

              <div class="form-group mb-3 input-group input-text-wrapper">
                <div class="input-group-prepend">
                  <span
                    class="input-group-text"
                    style="background-color: #ffffff; border: none"
                  >
                    <font-awesome-icon icon="envelope" style="color: #ced4da" />
                  </span>
                </div>
                <b-form-input
                  class="login-text-input"
                  id="input-email"
                  v-model="signup_email"
                  type="email"
                  required
                  placeholder="Email"
                ></b-form-input>
              </div>

              <div class="form-group mb-3 input-group input-text-wrapper">
                <div class="input-group-prepend">
                  <span
                    class="input-group-text"
                    style="background-color: #ffffff; border: none"
                  >
                    <font-awesome-icon icon="envelope" style="color: #ced4da" />
                  </span>
                </div>
                <b-form-input
                  class="login-text-input"
                  id="input-email"
                  v-model="signup_phone"
                  type="tel"
                  required
                  placeholder="Phone"
                ></b-form-input>
              </div>

              <b-form-group>
                <b-button
                  class="form-control signUpButtonCard button"
                  type="submit"
                  >Sign Up &nbsp;
                  <b-spinner
                    v-if="signUpSpinner"
                    small
                    label="Loading..."
                  ></b-spinner>
                </b-button>
              </b-form-group>

              <b-form-group>
                <b-card-text class="text-center">
                  <span style="color: #7a7a7a; font-size: 15px"
                    >Already have an account?
                    <a
                      class="inputLink"
                      @click="goToLogin"
                      href="javascript:void(0)"
                      >Login here</a
                    ></span
                  >
                </b-card-text>
              </b-form-group>

              <hr />

              <span>
                <p class="text-center">
                  <small>
                    By creating an account you are agreeing to the ePosta
                    customer
                    <a class="inputLink" href="javascript:void(0)"
                      >Terms and Conditions</a
                    >
                    &
                    <a class="inputLink" href="javascript:void(0)">
                      Privacy Policy
                    </a></small
                  >
                </p>
              </span>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import router from "@/configurations/router";

export default {
  name: "Home",
  data() {
    return {
      phone: null,
      code: null,
      code_returned: null,
      code_phone: null,
      showLogin: true,
      showEnterCode: false,
      showSignUp: false,
      signup_fname: null,
      signup_lname: null,
      signup_email: null,
      signup_phone: null,
      signUpSpinner: false,
      loginSpinner: false,
      search_service: null,
      serviceSearchSpinner: false,
      verifySpinner: false,
    };
  },
  computed: {
    ...mapGetters([
      "getStatus",
      "getSignUpResponse",
      "getLoginResponse",
      "getVerificationResponse",
      "getClientId",
      "getErrorMessage",
    ]),
    login_response() {
      return this.getLoginResponse;
    },
    verification_response() {
      return this.getVerificationResponse;
    },
    signup_error_response() {
      return this.getErrorMessage;
    },
    login_error_response() {
      return this.getErrorMessage;
    },

    verification_error() {
      return this.getErrorMessage;
    },
  },
  watch: {
    login_response(newValue) {
      var data = JSON.parse(JSON.stringify(newValue));
      let account = {
        client_id: data.client_id,
        phone: data.phone,
      };
      localStorage.setItem("eposta_session", JSON.stringify(account));
      this.loginSpinner = false;
      this.showEnterCode = true;
      this.showLogin = false;
    },
    verification_response(response) {
      let req = {
        client_id: this.getClientId,
      };
      this.fetchAccountInfo(req);

      this.$swal({
        title: response.status,
        text: response.message,
      });
      location.reload();

      router.push("/dashboard");
    },
    login_error_response(error) {
      this.$swal({
        title: error.status,
        text: error.message,
      });
      //this.showLogin = false
      this.loginSpinner = false;
    },
    signup_error_response(error) {
      this.$swal({
        title: error.status,
        text: error.message,
      });
      this.signUpSpinner = false;
    },
    verification_error(error) {
      this.$swal({
        title: error.status,
        text: error.message,
      });
      this.verifySpinner = false;
    },
    getSignUpResponse(data) {
      this.$swal({
        title: data.status,
        text: data.message,
      });
      this.signUpSpinner = false;
      this.showLogin = true;
      this.showSignUp = false;
    },
  },
  methods: {
    ...mapActions([
      "userLogin",
      "codeVerification",
      "signup",
      "fetchAccountInfo",
    ]),
    login: function (e) {
      e.preventDefault();
      let data = {
        phone: this.phone,
      };
      this.loginSpinner = true;
      this.userLogin(data);
    },
    verifyCode() {
      var client_id = this.getClientId;
      let data = {
        client_id: client_id,
        verify_code: this.code,
      };

      this.verifySpinner = true;

      this.codeVerification(data);
    },
    createAccount: function (e) {
      e.preventDefault();
      this.signUpSpinner = true;
      let data = {
        lname: this.signup_fname,
        fname: this.signup_lname,
        email: this.signup_email,
        phone: this.signup_phone,
      };
      this.signup(data);
    },
    goToSignUp: function () {
      this.showSignUp = true;
      this.showLogin = false;
    },
    goToLogin: function () {
      this.showLogin = true;
      this.showSignUp = false;
    },
    search_services: function () {
      alert("this will do the search");
    },
  },
};
</script>

<style scoped>
.login-text-input {
  border: none;
  font-size: 13px;
  color: #8898aa;
  box-shadow: none !important;
}

.searchButtonCard {
  border: none;
  color: #ffffff;
  box-shadow: 0 0px 4px 0 rgba(0, 0, 0, 0.14);
  background: #db0000;
  height: 49px;
  border-radius: 4px;
  text-align: center;
  font-size: 1.5vw;
  width: 35%;
}

.signUpButtonCard {
  border: none;
  color: #ffffff;
  box-shadow: 0 0px 4px 0 rgba(0, 0, 0, 0.14);
  font-weight: bold;
  background: #db0000;
  height: 45px;
  border-radius: 3px;
  text-align: center;
  font-size: 15px;
  margin-top: 3%;
}

.inputLink {
  text-decoration: none;
  color: #db0000;
}

.loginCard {
  box-shadow: 0 0px 4px 0 rgba(0, 0, 0, 0.14);
}

.name-search-text-input {
  border: none;
  height: 50px;
  color: #8898aa;
  width: 100px;
  outline: none;
  box-shadow: none !important;
}

.public-name-search-button {
  background: #db0000;
  border: none;
  color: #ffffff;
  text-align: center;
  width: 90px;
  border-radius: 0px 30px 30px 0px;
}

.search-input-text-wrapper {
  border: #ced4da 1px solid;
  box-shadow: 0 0px 4px 0 rgba(0, 0, 0, 0.14);
  border-radius: 30px 30px 30px 30px;
  padding-left: 2px;
  background-color: #ffffff;
}

.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  text-align: center;
  background-color: #ffffff;
}

/*---------------------------*/
.login {
  width: 100%;
  height: 100%;
  /* background-color: #c40000;
        background-size: cover;*/
}

.input-text-wrapper {
  border: #ced4da 1px solid;
  padding: 5px;
  box-shadow: 0 0px 4px 0 rgba(0, 0, 0, 0.14);
  border-radius: 5px;
}

.box {
  border-radius: 6px;
  margin: 50px;
  box-shadow: 8px 10px 28px #8a0010;
}

.left {
  width: 50%;
  height: 100%;
  background-color: #db0000;
  background-size: cover;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}

.right {
  width: 50%;
  height: 100%;
  background-color: #fff;
  background-size: cover;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}

.title-bar {
  background: #db0000;
  padding: 15px;
}

.links {
  color: #fff;
  list-style: none;
}

.links li {
  padding: 5px;
  display: inline;
}

.links .active {
  background: #9f0012;
  border-radius: 10px;
  padding: 9px;
}

.links li:hover {
  background: #9f0012;
  border-radius: 10px;
  padding: 9px;
}

li a {
  color: white;
  text-decoration: none;
}

.logo {
  width: 100px;
  height: 30px;
}

.salutations {
  margin-top: 73px;
}

.about-header {
  margin-top: 15px;
  margin-left: 20px;
  font-weight: bold;
}

.about-us {
  font-size: 16px;
  margin-top: 15px;
  margin-left: 20px;
  margin-right: 10px;
  text-align: left;
  text-justify: auto;
}

.form {
  width: 100%;
  margin-top: 45px;
  margin-left: 15px;
  margin-right: 15px;
}

.input {
  width: 100%;
  margin-bottom: 10px;
  border-radius: 0;
  border-bottom: solid 2px #db0000;
  border-top: 0;
  border-right: 0;
  border-left: 0;
  background: white;
}

.input:hover {
  border-top: 0;
  border-right: 0;
  border-left: 0;
  border-bottom: solid 2px #9f0012;
}

.input:focus {
  border-top: 0;
  border-right: 0;
  border-left: 0;
  border-bottom: solid 2px #9f0012;
}

.remember-prompt {
  margin-top: 3px;
  color: #db0000;
  font-size: 12px;
  font-weight: bold;
}

.code-prompt {
  margin-top: 3px;
  color: #222222;
  font-size: 12px;
  font-weight: bold;
}

.btns {
  width: 90%;
}

.text1 {
  font-size: 18px;
  color: #db0000;
  font-weight: 400;
}

.text2 {
  font-size: 18px;
  color: #4b4b4b;
}

.disclaimer {
  margin-top: 100px;
  margin-bottom: 48px;
}

.disclaimer-signup {
  margin-top: 28px;
  margin-bottom: 10px;
}

.disclaimer-text {
  font-size: 11px;
  color: #222;
  font-style: italic;
}

.button {
  width: 100%;
  background: #db0000;
  border: none;
  border-radius: 2px;
  color: #fff;
  padding: 8px 10px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 14px;
}

.button:hover {
  background: #9f0012;
}
</style>
